module.exports = __webpack_public_path__ + "media/src/images/landing/micro-bit-icon-2a892362e88b647cf36bb68cf4d6b7fe.png";